import { createSlice } from "@reduxjs/toolkit";

export const initialState: {
  loading: boolean;
  successMsg: { message: string; id: string };
  errorMsg: { message: string; id: string };
} = {
  loading: false,
  successMsg: { message: "", id: "" },
  errorMsg: { message: "", id: "" },
};

const lickycSlice = createSlice({
  name: "lickyc",
  initialState,
  reducers: {
    setLickycLoader(state, action) {
      state.loading = action.payload;
    },
    importExcelSuccessMsg(state, action) {
      state.successMsg.message = action.payload.message;
      state.successMsg.id = action.payload.id;
    },
    importExcelErrorMsg(state, action) {
      state.errorMsg.message = action.payload.message;
      state.errorMsg.id = action.payload.id;
    },
  },
});

export const {
  setLickycLoader,
  importExcelSuccessMsg,
  importExcelErrorMsg,
} = lickycSlice.actions;

export default lickycSlice.reducer;
